import "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";

import React, { Component, Fragment, StrictMode } from "react";
import PropTypes from "prop-types";

import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";

import viewportUnitsBuggyfill from "viewport-units-buggyfill";
import hacks from "viewport-units-buggyfill/viewport-units-buggyfill.hacks";
import { trackHomePageVisit } from "~/libs/matomo";

import Annotationeer from "~/components/Annotationeer";
import Header from "~/components/Header";
import LeftSidebar from "~/components/LeftSidebar";
import RightSidebar from "~/components/RightSidebar";
import ModalPortal from "~/components/Modal/Portal";
import ZoomController from "~/components/ZoomController";
import theme from "./themes/mildenberger";

const globalStyles = {
  ":root": {
    "--dsb-outline-color": theme.palette.outline.primary
  },
  "*:focus-visible": {
    // outline: "2px solid red !important"
  },
  "#app": {
    height: "100%"
  },
  "[hidden], [class='hidden']": {
    display: "none"
  },
  "[class*='MuiIconButton-root']": {
    borderRadius: 0
  },
  "[class*='MuiIconButton-root'] [class*='MuiSvgIcon-root']": {
    fontSize: "2.4rem"
  },
  "[class*='MuiToggleButton-root'] [class*='MuiSvgIcon-root']": {
    fontSize: "2.4rem"
  },
  "[class*='MuiTab-root'] [class*='MuiSvgIcon-root']": {
    fontSize: "2.4rem"
  },
  "[class*='MuiAvatar-root'] [class*='MuiSvgIcon-root']": {
    fontSize: "2.4rem"
  },
  "[class*='MuiTooltip-tooltip']": {
    fontSize: "1em !important"
  },
  "[class*='MuiTooltip-popper']": {
    // TODO: QuickDialAction Tooltip in ViewerModal wird sonst überdeckt/nicht angezeigt
    zIndex: "5500 !important"
  }
};

try {
  // Firefox Developer Edition [59.0b13 (64-bit)]
  // Error: Permission denied to access property "mediaText"
  // https://github.com/bdkjones/CodeKit/issues/416
  viewportUnitsBuggyfill.init({ hacks, force: true, refreshDebounceWait: 250 });
} catch (err) {
  console.error(err);
}

class App extends Component {
  constructor(props) {
    super(props);

    this.renderAnnotationeer = this.renderAnnotationeer.bind(this);
    this.onContextMenu = this.onContextMenu.bind(this);
  }

  componentDidMount() {
    this.props.onApplicationStart();

    trackHomePageVisit();

    try {
      // Firefox Developer Edition [59.0b13 (64-bit)]
      // Error: Permission denied to access property "mediaText"
      // https://github.com/bdkjones/CodeKit/issues/416
      viewportUnitsBuggyfill.refresh();
    } catch (err) {
      console.error(err);
    }

    document.addEventListener("contextmenu", this.onContextMenu, false);
  }

  componentWillUnmount() {
    document.removeEventListener("contextmenu", this.onContextMenu, false);
  }

  onContextMenu(event) {
    event.preventDefault();
  }

  renderAnnotationeer(zoomController) {
    console.log("Annotationeer", Annotationeer);
    return <Annotationeer zoomController={zoomController} />;
  }

  render() {
    return (
      <>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />

        <StrictMode>
          <Header />

          <LeftSidebar />
          <RightSidebar />

          <ZoomController channel="main">{this.renderAnnotationeer}</ZoomController>

          <ModalPortal />
        </StrictMode>
      </>
    );
  }
}

App.propTypes = {
  onApplicationStart: PropTypes.func.isRequired
};

export default App;
